// Feedback.js
import React, { useState } from 'react';
import { executeQuery } from '@components/executeQuery';
import { FaRegThumbsUp, FaRegThumbsDown, FaThumbsUp, FaThumbsDown } from 'react-icons/fa';

const Feedback = ({ messageId, userEmail }) => {
  const [feedback, setFeedback] = useState(null);

  const handleFeedback = async (type) => {
    if (feedback) return;

    const isPositive = type === 'like' ? 1 : 0;
    setFeedback(type);

    // Update feedback directly in conversation_website
    const query = `UPDATE conversation_website SET is_positive = ? WHERE id = ? AND user_id = ?;`;
    const values = [isPositive, messageId, userEmail];

    try {
      await executeQuery(query, values);
    } catch (error) {
      console.error('Error saving feedback:', error);
    }
  };

  return (
    <div className="d-flex justify-content-start gap-2 ms-3">
      <div className={`feedback-icon ${feedback === 'like' ? 'text-dark' : 'text-muted'}`} onClick={() => handleFeedback('like')}
        style={{ fontSize: '1.3rem', cursor: 'pointer' }}>
        {feedback === 'like' ? <FaThumbsUp /> : <FaRegThumbsUp />}
      </div>
      <div className={`feedback-icon ${feedback === 'dislike' ? 'text-dark' : 'text-muted'}`} onClick={() => handleFeedback('dislike')}
         style={{ fontSize: '1.3rem', cursor: 'pointer' }}>
        {feedback === 'dislike' ? <FaThumbsDown /> : <FaRegThumbsDown />}
      </div>
    </div>
  );
};

export default Feedback;
